module.exports = __webpack_public_path__ + "static/1-443fd4820931e0f1827dac31f47f2c48.jpg";